import request from '../utils/request'

export default {
  async lists(data) { // 获取型号列表
    const ret = await request('/v1/deviceModel/lists', data, 'POST')
    return ret
  },

  async selectList(data) { // 获取型号下拉列表
    const ret = await request('/v1/deviceModel/selectList', data, 'POST')
    return ret
  },

  async operate(data) { // 添加/编辑型号
    const ret = await request('/v1/deviceModel/operate', data, 'POST')
    return ret
  },

  async delete(data) { // 删除型号
    const ret = await request('/v1/deviceModel/delete', data, 'POST')
    return ret
  },

  async detail(data) { // 型号详情
    const ret = await request('/v1/deviceModel/detail', data, 'POST')
    return ret
  }
}
